// User-level role hierarchy for TAS Portal.
/** Higher number = more authority. */
export const ROLE_RANK = {
    viewer: 1,
    staff: 2,
    admin: 3,
    owner: 4,
};
export function hasAtLeastRole(actual, required) {
    return ROLE_RANK[actual] >= ROLE_RANK[required];
}
